import { Button, Modal, useToast } from "@nabble/ui";
import { useState } from "react";
import { updateUserAccess, type AdminUser } from "../../../api/adminUsers";
import { errorMessage } from "../../../errors";
import { SuiteAccessFields } from "./SuiteAccessFields";

interface UserAccessDialogProps {
  user: AdminUser;
  onClose: () => void;
  onSaved: () => void;
}

/** Edits whether a user is a suite administrator; the roles they hold are set per organization. */
export function UserAccessDialog({ user, onClose, onSaved }: UserAccessDialogProps): React.JSX.Element {
  const { show } = useToast();
  const [suiteAdmin, setSuiteAdmin] = useState(user.suiteAdmin);
  const [loading, setLoading] = useState(false);

  async function submit(): Promise<void> {
    setLoading(true);
    try {
      await updateUserAccess(user.id, suiteAdmin);
      show({ title: "Access updated", text: `${user.displayName}'s access to the whole suite was saved.`, tone: "success" });
      onSaved();
    } catch (err) {
      show({ title: "We couldn't update the access", text: errorMessage(err, "Please try again."), tone: "danger" });
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal
      open
      icon="key"
      title={`Admin Center access of ${user.displayName}`}
      description="The roles they hold in each organization are set from Organizations. This is about the whole suite."
      onClose={onClose}
      actions={
        <>
          <Button label="Cancel" variant="secondary" onClick={onClose} />
          <Button label="Save" loading={loading} onClick={() => void submit()} />
        </>
      }
    >
      <div className="nb-stack">
        <SuiteAccessFields suiteAdmin={suiteAdmin} onChange={setSuiteAdmin} />
      </div>
    </Modal>
  );
}
